/** @format */

import { CommonModule, DOCUMENT } from '@angular/common';
import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	PLATFORM_ID,
	Renderer2,
	SimpleChange,
	ViewChild,
	OnDestroy,
	inject
} from '@angular/core';
import { AnalyticsService } from '@shared/data-access/services';
import {
	homefieldIconAlertInfoOutlined,
	homefieldIconBuildingStoreDsgAlt,
	HomefieldIconLibraryModule,
	homefieldIconOrderDelivery,
	homefieldIconSignCancel,
	homefieldIconSignCheck,
	HomefieldIconsLibraryService,
	homefieldIconVehicleShipping
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'common-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrl: './side-nav.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule]
})
export class SideNavComponent implements OnChanges, OnDestroy {
	protected readonly platformId = inject(PLATFORM_ID);
	private readonly analyticsService = inject(AnalyticsService);
	private readonly renderer = inject(Renderer2);
	private readonly document = inject(DOCUMENT);
	private readonly eleRef = inject(ElementRef);
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconBuildingStoreDsgAlt,
			homefieldIconVehicleShipping,
			homefieldIconAlertInfoOutlined,
			homefieldIconSignCheck,
			homefieldIconOrderDelivery,
			homefieldIconSignCancel
		]);
	}

	@Input() modalName = 'Default Modal';
	@Input() isSidePanelToggled: boolean;
	@Input() panelBodyClass = '';
	@Input() panelContainerClass = '';
	@Input() side = 'right';
	@Input() zipConfirm;
	@Input() addFlexBox = false;
	@Input() isFormEmpty = true;

	@Output() panelEvent = new EventEmitter();

	/**
	 * @description
	 * Whether or not the panel should be displayed
	 */
	public showContent = false;

	@ViewChild('sidePanel', { static: false })
	sidenav: any;

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		if (this.sidenav !== undefined) {
			if (this.isSidePanelToggled) {
				this.panelToggle('open');
			} else {
				this.panelToggle('close');
			}
		}
	}

	ngOnDestroy(): void {
		if (this.showContent) {
			// Side nav is still open (although it may not be displaying) so we have to
			this.panelToggle('close');
		}
	}

	public panelToggle(event: string) {
		if (event === 'open') {
			this.showContent = true;

			this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
			this.renderer.addClass(this.document.body, 'side-panel-open');

			this.sendAnalyticsFor(this.modalName);

			this.panelEvent.emit({ opened: true });
			this.eleRef.nativeElement.focus();
		} else {
			/*
			 * Closed
			 */
			this.showContent = false;

			this.renderer.setStyle(this.document.body, 'overflow', 'visible');
			this.renderer.removeClass(this.document.body, 'side-panel-open');

			this.panelEvent.emit({ opened: false });
			this.eleRef.nativeElement.blur();
		}
	}

	public sendAnalyticsFor(name: string) {
		/*
		 * Analytics Event
		 */
		// Set the modal name
		this.analyticsService.setModalName(name);

		// Set the Analytics event type
		this.analyticsService.setType('event', 'ModalOpen');

		// Trigger the Analytics update
		this.analyticsService.triggerAnalyticsEvent('reporting:update');
	}
}
